module.exports = __webpack_public_path__ + "img/upload.e3defb43.svg";